import Vue from 'vue';
import Router from 'vue-router';
import VHome from './views/VHome.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  // history: true,
  // hashbang: false,
  base: process.env.BASE_URL,
  routes: [
    { path: '/', name: 'home', component: VHome/*, redirect: '/login',*/ },
    { path: '/login', name: 'login', component: () => import('@/views/VLogin.vue') },
    { path: '/events', name: 'events', component: () => import('@/views/VEvents.vue') },
    { path: '/support', name: 'support', component: () => import('@/views/VSupport.vue') },
    { path: '/settings', name: 'settings', component: () => import('@/views/VSettings.vue') },
    { path: '/addresses', name: 'addresses', component: () => import('@/views/VAddresses.vue') },
    // { path: '/statistics', name: 'statistics', component: () => import('@/views/VStatistics.vue') },
    { path: '/controllers', name: 'controllers', component: () => import('@/views/VControllers.vue') },
    { path: '/passwordreset', name: 'passwordreset', component: () => import('@/views/VPasswordReset.vue') },
    { path: '/controller/:id', name: 'controller',
      // props(route) {
      //   const props = { ...route.params };
      //   props.id = +props.id;
      //   return props;
      // },
      props: true,
      component: () => import('@/views/VController.vue') },
    { path: '/mccontrollers', name: 'mccontrollers', component: () => import('@/views/VControllers4MCs.vue') },
    // { path: '/address/:addressid(\d*)', name: 'address', component: () => import('@/views/VAddress.vue') },
    // {
    //   path: '/about', name: 'about',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
    // },
  ],
});
